module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('amounts-component', {
    attrs: {
      "subsidiary-id": _vm.params.idSubsidiary
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "hide-details": "",
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "single-line": ""
    },
    on: {
      "input": _vm.onChangeSubsidiary
    },
    model: {
      value: (_vm.params.idSubsidiary),
      callback: function($$v) {
        _vm.params.idSubsidiary = $$v
      },
      expression: "params.idSubsidiary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "pr-2": ""
    }
  }, [_c('v-layout', {
    staticClass: "bar-information",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "py-2": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-right",
    attrs: {
      "xs2": "",
      "pr-2": ""
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/key-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "text-xs-left": "",
      "pl-2": ""
    }
  }, [_c('label', {
    staticClass: "bar-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tHabitaciones:\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "bar-text"
  }, [_vm._v(_vm._s(_vm.dashboard.numRooms))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-right",
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/cancel-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "text-xs-left": "",
      "pl-2": ""
    }
  }, [_c('label', {
    staticClass: "bar-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tInactivas:\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "bar-text"
  }, [_vm._v(_vm._s(_vm.dashboard.lockedRooms))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-right",
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/adult-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "text-xs-left": "",
      "pl-2": ""
    }
  }, [_c('label', {
    staticClass: "bar-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAdultos:\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "bar-text"
  }, [_vm._v(_vm._s(_vm.dashboard.adults))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-right",
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/child-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "text-xs-left": "",
      "pl-2": ""
    }
  }, [_c('label', {
    staticClass: "bar-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tNiños:\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "bar-text"
  }, [_vm._v(_vm._s(_vm.dashboard.childrens))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/calendar-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('label', {
    staticClass: "bar-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tFecha:\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "bar-text"
  }, [_vm._v(_vm._s(_vm.dashboard.date))])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-2": ""
    }
  }, [_c('v-layout', {
    staticClass: "bar-information",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "py-1": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select type-room-select",
    attrs: {
      "hide-details": "",
      "placeholder": "Tipo de Habitación",
      "items": _vm.roomsTypes,
      "item-text": "name",
      "item-value": "id"
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.roomTypeId),
      callback: function($$v) {
        _vm.params.roomTypeId = $$v
      },
      expression: "params.roomTypeId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-start": "",
      "align-center": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2",
    attrs: {
      "height": "259px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "bar-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tCaja:\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "text-xs-right": "",
      "pl-4": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select filter-select-slot",
    attrs: {
      "items": _vm.currencies,
      "item-text": "code",
      "item-value": "code",
      "max-height": "auto",
      "hide-details": ""
    },
    on: {
      "input": _vm.loadAmounts
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-avatar', [_c('img', {
          attrs: {
            "src": data.item.img
          }
        })]), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(data.item.code) + "\n\t\t\t\t\t\t\t")]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-tile-avatar', [_c('img', {
          attrs: {
            "src": data.item.img
          }
        })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.code)
          }
        })], 1)]
      }
    }]),
    model: {
      value: (_vm.params.currency),
      callback: function($$v) {
        _vm.params.currency = $$v
      },
      expression: "params.currency"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "categories-container",
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [(_vm.isLoading) ? _c('span', {
    staticClass: "loading"
  }, [_vm._v("Cargando...")]) : _vm._l((_vm.amounts), function(category, categoryIndex) {
    return _c('v-flex', {
      key: category.id,
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": "",
        "py-0": "",
        "text-xs-left": ""
      }
    }, [_c('p', {
      staticClass: "category-name"
    }, [_vm._v(_vm._s(category.name))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs5": "",
        "pa-0": ""
      }
    }, [_c('v-progress-linear', {
      staticClass: "my-0",
      attrs: {
        "value": category.percentage,
        "height": "3",
        "color-front": category.color,
        "color-back": "grey"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "pl-0": "",
        "py-0": "",
        "text-xs-right": ""
      }
    }, [_c('p', {
      staticClass: "category-name"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.params.currency) + " " + _vm._s(_vm._f("round")(category.amount)) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), (categoryIndex < (_vm.amounts.length - 1)) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "py-0": ""
      }
    }, [_c('v-divider')], 1) : _vm._e()], 1)], 1)
  })], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-end": "",
      "justify-end": "",
      "px-1": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('p', {
    staticClass: "category-total"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.params.currency) + " " + _vm._s(_vm._f("round")(_vm.totalAmount)) + "\n\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2",
    attrs: {
      "height": "259px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "bar-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tEstados:\n\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "px-1": ""
    }
  }, _vm._l((_vm.dashboard.states), function(state, indexState) {
    return _c('state-box', {
      key: indexState,
      attrs: {
        "state": state
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2",
    attrs: {
      "height": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "bar-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tDisponibilidad del día:\n\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "position-relative",
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-chart', {
    attrs: {
      "type": "doughnut",
      "data": _vm.chartDataAvailability,
      "options": _vm.optionsChartAvailability
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "total-amount"
  }, [_c('span', [_vm._v(_vm._s(_vm.dashboard.availability.percent.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dashboard.availability.percent.value) + "%")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2 customers-card",
    attrs: {
      "height": "232"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "bar-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tCuentas por cobrar:\n\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "px-1": ""
    }
  }, [_c('v-flex', {
    staticClass: "customers-table"
  }, [_c('table-run', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": false,
      "include-settings": false,
      "include-switch": false,
      "include-search": false,
      "selectable": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.rzSocial))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getChannel(props.row)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getEmployee(props.row)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.numReserve))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.amountPayment))]), _vm._v(" "), _c('td', {
          class: {
            'red-color-amount': _vm.majorCero(props.row)
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.pendingAmount) + "\n\t\t\t\t\t\t\t\t")])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-left": "",
      "pl-3": ""
    }
  }, [_c('label', {
    staticClass: "bar-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tEstados de habitaciones\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "text-xs-left": "",
      "pl-5": ""
    }
  }, [_c('v-layout', {
    staticClass: "bar-caption",
    attrs: {
      "align-center": "",
      "justify-end": ""
    }
  }, _vm._l((_vm.status), function(status, indexState) {
    return (status.name === 'Check In' || status.name === 'Pendientes' || status.name === 'Check Out' || status.name === 'In House' || status.name === 'No-show' || status.name === 'Reservas') ? _c('button', {
      key: indexState,
      staticClass: "btn-state",
      on: {
        "click": function($event) {
          _vm.updateDashboard(status.id)
        }
      }
    }, [_c('label', {
      staticClass: "bar-caption-text"
    }, [_c('span', {
      staticClass: "bar-caption-color booking",
      style: (("background-color: " + (status.colors)))
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(status.name) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), (!_vm.reservationState) ? _c('img', {
      attrs: {
        "src": ("" + _vm.$imageS3 + (status.img))
      }
    }) : _c('span', {
      staticClass: "bar-caption-icon booking",
      style: (("background-color: " + (status.colors)))
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tR\n\t\t\t\t\t\t\t\t\t")])]) : _vm._e()
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, _vm._l((_vm.bookings), function(booking) {
    return _c('housekeeping-card', {
      key: booking.id,
      attrs: {
        "flag-observed": booking.flagObserved,
        "room-number": booking.roomNumber,
        "room-type-code": booking.roomTypeCode,
        "lastname": booking.customerLastname,
        "name": booking.customerName,
        "start-date": booking.bookingStart,
        "end-date": booking.bookingEnd,
        "currency": booking.currency,
        "booking-total": booking.total,
        "booking-color": booking.color,
        "booking-state": booking.bookingState,
        "href": booking.href
      }
    })
  }))], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a6aed48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/dashboard/Dashboard.vue
// module id = 1594
// module chunks = 18